import api from './httpService';

type CreateGymUserPayload = {
    email: string;
    role: string;
    password: string;
    isActive: boolean;
};

type UpdateGymUserPayload = {
    gymName: string;
    email: string;
    mobile: string;
    address: string;
    role: string;
    password?: string;
    isActive: boolean;
};

const readArray = (value: unknown): unknown[] => {
    if (Array.isArray(value)) return value;
    if (value && typeof value === 'object') {
        const data = value as { data?: unknown; users?: unknown; items?: unknown };
        if (Array.isArray(data.data)) return data.data;
        if (Array.isArray(data.users)) return data.users;
        if (Array.isArray(data.items)) return data.items;
    }
    return [];
};

export const getGymUsers = async () => {
    const response = await api.get('/users');
    return readArray(response.data);
};

export const addGymUser = async (payload: CreateGymUserPayload) => {
    const response = await api.post('/users', payload);
    return response.data;
};

export const updateGymUser = async (id: string, payload: UpdateGymUserPayload) => {
    const response = await api.put(`/users/${id}`, payload);
    return response.data;
};

export const deleteGymUser = async (id: string) => {
    const response = await api.delete(`/users/${id}`);
    return response.data;
};
